module.exports = __webpack_public_path__ + "static/img/图层523.382e5e6a.png";